import {
  CONTACT_EVENT_STATE_MAP,
  CONTACT_STATE_MAP,
  CHANNEL_TYPES,
  LOG_PREFIX,
  STATE_CASE,
} from "../../constants/constants";
import { IndividualTask } from "../models/task";
import { formatCaseAttributes } from "../../utils";
import { clearCurrentTaskContact, disconnectTaskContact } from "../api/task";
import { changeAgentStateToAvailable } from "./agent";
import Emitter from "../../emitter";
import storeRTK from "../../store/storeRTK";
import { setActiveCaseUpdate } from "../../actions/case";
import { API_MILO_CASE_CHANNEL_TRANSACTION } from "../../constants/events";
import { API_CONTACT_EVENT_LOGGING, STATE_MISSED_CASE } from "../constants";
import Player from "../../utils/audio/player";
const lp = LOG_PREFIX + "[handlers.task.ts]: ";
const defaultValue = { self: {}, customer: {} };

let tasks: { [key: string]: IndividualTask } = {};

export const casePlayer = new Player({ type: "CASE", loop: true });

export function setTask(taskObj: IndividualTask) {
  if (!taskObj.id) return;

  //Below ignore duplicate task ended events

  const existingTask = tasks.hasOwnProperty(taskObj?.id);
  if (taskObj.self?.state === CONTACT_STATE_MAP.ENDED && !existingTask) return;
  if (taskObj.self?.state === CONTACT_STATE_MAP.ENDED) {
    if (taskObj?.id && tasks.hasOwnProperty(taskObj?.id)) {
      delete tasks[taskObj.id];
    }
  } else {
    if (taskObj?.id) tasks[taskObj.id] = JSON.parse(JSON.stringify(taskObj));
  }
}

export function handleIncomingTask(contact: any) {
  // Check if the contact is already connected
  // const isConnected = contact.getStatus().type === "connected";

  // if (!isConnected) {
  //   notificationManager.playRingtone(RING_TYPES.CASE);
  // }

  console.log(lp + "Incoming task contact: ", contact);
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.INCOMING, contact);
  return {
    contactId: contact.contactId || contact.getContactId(),
    eventType: CONTACT_EVENT_STATE_MAP.RINGING,
    channel: CHANNEL_TYPES.TASK,
  };
}
export function handleConnectingTask(contact: any) {
  console.log(lp + "CONNECTING task contact: ", contact);
  //updateTaskAndSend(CONTACT_EVENT_STATE_MAP.CONNECTING, contact);
}

export function handleMissedTask(contact: any) {
  console.log(lp + "MISSED task contact: ", contact);

  // Get customer information for the missed task notification
  const customerEndpoint = contact.getActiveInitialConnection()?.getEndpoint();
  const customerAttributes = formatCaseAttributes(contact.getAttributes());
  const queueInfo = contact.getQueue();
  const agentConnection = contact.getAgentConnection();
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.MISSED,
      channel: CHANNEL_TYPES.TASK,
    },
  });
  try {
    // Emit enhanced missed task event for notifications
    Emitter.emit(STATE_MISSED_CASE, {
      chan: STATE_MISSED_CASE,
      body: {
        contactId: contact.contactId || contact.getContactId(),
        eventType: CONTACT_EVENT_STATE_MAP.MISSED,
        channel: CHANNEL_TYPES.TASK,
        // Customer information
        customerName: customerAttributes?.FIRSTNAME + ' ' + customerAttributes?.LASTNAME ||
          customerEndpoint?.name ||
          'Unknown Customer',
        phoneNumber: customerEndpoint?.phoneNumber ||
          customerAttributes?.Customer_ANI ||
          customerAttributes?.Customer_Phone ||
          'Unknown Number',
        // Queue information
        queueName: queueInfo?.name || 'Unknown Queue',
        queueId: queueInfo?.queueARN || null,
        // Contact details
        direction: contact.isInbound() ? 'INBOUND' : 'OUTBOUND',
        contactStartTime: agentConnection.getState().timestamp || new Date().toISOString(),
        missedAt: new Date().toISOString(),
        // Additional attributes that might be useful
        customerAttributes: customerAttributes,
        // Agent context
        agentId: agentConnection?.connectionId || null,
        // Contact duration (if available)
        contactDuration: (new Date().getTime() - new Date(agentConnection.getState().timestamp).getTime()) || 0,
        // Task specific information
        taskType: customerAttributes?.Task_Type || 'General Task',
        taskPriority: customerAttributes?.Task_Priority || 'Normal',
        caseId: customerAttributes?.Case_ID || null,
      },
    });
  } catch (error) {
    console.log(lp + "Error emitting STATE_MISSED_CASE event", error);
  }
  // changeAgentStateToAvailable();
  clearCurrentTaskContact(contact.contactId || contact.getContactId());
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.MISSED, contact);
}

export function handleDestroyTask(contact: any) {
  console.log(lp + "DESTROY task contact: ", contact);
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.DESTROYED, contact);
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact.contactId || contact.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.RELEASED,
      channel: CHANNEL_TYPES.TASK,
    },
  });
}

export function handleAcceptedTask(contact: any) {
  console.log(
    lp +
    "ACCEPTED task contact: accepted by agent. Contact state is " +
    contact.getStatus().type,
    contact
  );
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ACCEPTED, contact);
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact.contactId || contact.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.ESTABLISHED,
      channel: CHANNEL_TYPES.TASK,
    },
  });
}
export function handleConnectedTask(contact: any) {
  console.log(
    lp +
    "CONNECTED task contact: connected to agent. Contact state is " +
    contact.getStatus().type,
    contact
  );
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.CONNECTED, contact);
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact.contactId || contact.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.ESTABLISHED,
      channel: CHANNEL_TYPES.TASK,
    },
  });
  // Send message to bg to open milo URL
  Emitter.emit(API_MILO_CASE_CHANNEL_TRANSACTION, {
    type: "notif",
    chan: API_MILO_CASE_CHANNEL_TRANSACTION,
    body: {
      contactId: contact.contactId || contact.getContactId(),
    },
  });
}

export function handleRefreshTask(contact: any) {
  try {
    updateTaskAndSend(CONTACT_EVENT_STATE_MAP.REFRESH, contact);
  } catch (e) {
    console.log("Error in RefreshTask error : ", e);
    handleEndedTask(contact);
  }
}

export function handleEndedTask(contact: any) {
  console.log(
    `${lp} contact ${contact.getContactId()} ENDED task contact: has ended. Contact state is ${contact.getStatus().type
    }`
  );
  updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, contact);
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact.contactId || contact.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.ENDED,
      channel: CHANNEL_TYPES.TASK,
    },
  });
  if (contact.getStatus().type === "error") {
    console.log(
      `${lp} contact ${contact.getContactId()} ERROR task contact: has ended. Contact state is ${contact.getStatus().type
      }`
    );
  }
}

export function updateTaskAndSend(type: any, contact: any) {
  const existingTask = Object.assign(
    {},
    tasks[contact.contactId || contact.getContactId()]
  );
  let task = updateTask(type, contact);
  //   storeRTK.dispatch(setActiveCaseUpdate(task?.id));
  if (JSON.stringify(existingTask) === JSON.stringify(task)) return;
  console.log(
    lp + "Updated Task:",
    JSON.stringify(task),
    "Existing Task:",
    JSON.stringify(existingTask)
  );
  if (task) {
    // setTask({ ...task });
    storeRTK.dispatch(setActiveCaseUpdate(task?.id));
    Emitter.emit(STATE_CASE, { body: task });
    setTask({ ...task });
  }
  task = null;
}

function updateTask(
  contactEventType: string,
  contact: any
): IndividualTask | null {
  try {
    let id = contact.contactId || contact.getContactId();
    let task: any = tasks[id];
    let updatedCase: any;
    switch (contactEventType) {
      case CONTACT_EVENT_STATE_MAP.INITIAL:
        try {
          const cstate = contact.getState();
          const ctype: string = cstate?.type;
          let cstate_type: string = (CONTACT_EVENT_STATE_MAP as any)[
            ctype.toUpperCase()
          ];
          if (
            cstate_type === CONTACT_EVENT_STATE_MAP.ENDED ||
            ctype === "error"
          ) {
            return task;
          }
        } catch (error) {
          console.log(
            lp + "Error during state check of task contact",
            contact,
            error
          );
        }

        // This handling handles initial scenerio when chat event arrieves first time
        if (!task) {
          // Get cases from Redux store
          const cases = storeRTK.getState().cases.cases;
          const contactId = contact.contactId || contact.getContactId();
          const caseExists = cases.some(
            (c: IndividualTask) => c.id === contactId
          );

          // Only call setTask if the case exists
          if (caseExists) {
            const existingTask = cases.find(
              (c: IndividualTask) => c.id === contactId
            );
            task = existingTask;
          } else {
            task = defaultValue;
          }
        }
        updatedCase = {
          ...task,
          id: contact.contactId || contact.getContactId(),
          self: {
            ...task.self,
            id: contact.getAgentConnection().connectionId,
            state: CONTACT_STATE_MAP.INCOMING,
            userId: contact.getAgentConnection().getConnectionId(),
            queueId: contact.getAgentConnection().getConnectionId(),
            type: "AGENT",
            attributes: {},
            connectedTime: task?.self?.connectedTime || undefined,
          },
          conversationMedia: "",
          selfState: CONTACT_STATE_MAP.INCOMING,
          customer: {
            ...task.customer,
            state: CONTACT_STATE_MAP.CONNECTED,
            attributes: formatCaseAttributes(contact.getAttributes()),
            address:
              formatCaseAttributes(contact.getAttributes())?.PHONE_NUMBER ||
              " NA",
            type: "CUSTOMER",
          },
        };
        return updatedCase;

      case CONTACT_EVENT_STATE_MAP.INCOMING:
        break;
      case CONTACT_EVENT_STATE_MAP.ACCEPTED:
      case CONTACT_EVENT_STATE_MAP.CONNECTED:
        updatedCase = {
          ...task,
          self: {
            ...task.self,
            state: CONTACT_STATE_MAP.CONNECTED,
            connectedTime: task?.self?.connectedTime || new Date().getTime(),
          },
          selfState: CONTACT_STATE_MAP.CONNECTED,
          customer: {
            ...task.customer,
            attributes: formatCaseAttributes(contact.getAttributes()),
            type: "CUSTOMER",
          },
        };

        if (!updatedCase.customer.name) {
          updatedCase.customer.name =
            contact.getAttributes()?.customerName?.value || "";
        }
        return updatedCase;

      case CONTACT_EVENT_STATE_MAP.MISSED:
        const contactId = contact.contactId || contact.getContactId();
        updatedCase = {
          ...task,
          self: {
            ...task?.self,
            missed: true,
            state: CONTACT_STATE_MAP.ENDED,
            endTime: task?.self?.endTime || new Date().getTime(),
          },
          selfState: CONTACT_STATE_MAP.ENDED,
        };
        return updatedCase;
      case CONTACT_EVENT_STATE_MAP.ENDED:
      case CONTACT_EVENT_STATE_MAP.DESTROYED:
        updatedCase = {
          ...task,
          self: {
            ...task?.self,
            state: CONTACT_STATE_MAP.ENDED,
            connectedTime: task?.self?.connectedTime || new Date().getTime(),
            missed: [
              CONTACT_EVENT_STATE_MAP.REJECTED,
              CONTACT_EVENT_STATE_MAP.MISSED,
            ].includes(contact.getState()?.type?.toUpperCase()),
          },
          selfState: CONTACT_STATE_MAP.ENDED,
          customer: {
            ...task?.customer,
          },
        };
        if (!updatedCase.self.endTime) {
          updatedCase.self.endTime = new Date().getTime();
        }
        return updatedCase;

      case CONTACT_EVENT_STATE_MAP.REFRESH:
        const state = contact.getState();
        const type: string = state.type;
        if (type === "error") {
          if ((task && task.id === contactId) || !task?.id) {
            disconnectTaskContact({ conversationId: contactId });
            break;
          }
        }
        break;
      default:
        break;
    }
    return task;
  } catch (err) {
    console.log(lp + "Error from updateTask" + err);
    return null;
  }
}
